// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-answer-container {
    position: absolute;
    bottom: 100%;
    left: 4rem;
    right: 4rem;
    text-align: left;
    background-color: rgb(240, 240, 240);
    border-radius: 4px;
    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);
    padding: 4px 8px;
    z-index: 10;
}

.quick-answer {
    cursor: pointer;
    padding-left: .3rem;
    padding-right: .3rem;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    position: relative;
}

.quick-answer:hover .quick_answer__close {
    opacity: 1;
}

.quick_answer__counter {
    background-color: #26a69a;
    border-radius: 100%;
    padding: 0.5rem 1rem;
    font-size: small;
    color: white;
}

.quick_answer__text {
    font-size: 1.6rem;
    margin-left: 2rem;
    display: -webkit-inline-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.quick_answer__text.selected {
    background-color: #26a69a;
    border-radius: 4px;
}

.quick_answer__text.selected:hover {
    background-color: #26a69a;
    border-radius: 4px;
}

.quick_answer__text:hover {
    background-color: #26a69a;
    border-radius: 4px;
    color: #fff;
}

.quick_answer__close {
    opacity: 0;
    width: 2rem;
    text-align: center;
    font-size: initial;
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%)
}

.quick_answer__close:hover {
    background-color: #26a69a;
    border-radius: 4px;
    color: #fff;
}

.quick-answer:hover .quick_answer__text {
    background-color: #26a69a;
    color: #fff;
    border-radius: 4px;
}

`, "",{"version":3,"sources":["webpack://./src/app/chat/quick-answer-dialog/QuickAnswerDialog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,uGAAuG;IACvG,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".quick-answer-container {\r\n    position: absolute;\r\n    bottom: 100%;\r\n    left: 4rem;\r\n    right: 4rem;\r\n    text-align: left;\r\n    background-color: rgb(240, 240, 240);\r\n    border-radius: 4px;\r\n    box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%), 0 1px 5px 0 rgb(0 0 0 / 20%);\r\n    padding: 4px 8px;\r\n    z-index: 10;\r\n}\r\n\r\n.quick-answer {\r\n    cursor: pointer;\r\n    padding-left: .3rem;\r\n    padding-right: .3rem;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 0.5rem 0;\r\n    position: relative;\r\n}\r\n\r\n.quick-answer:hover .quick_answer__close {\r\n    opacity: 1;\r\n}\r\n\r\n.quick_answer__counter {\r\n    background-color: #26a69a;\r\n    border-radius: 100%;\r\n    padding: 0.5rem 1rem;\r\n    font-size: small;\r\n    color: white;\r\n}\r\n\r\n.quick_answer__text {\r\n    font-size: 1.6rem;\r\n    margin-left: 2rem;\r\n    display: -webkit-inline-box;\r\n    -webkit-line-clamp: 1;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n}\r\n\r\n.quick_answer__text.selected {\r\n    background-color: #26a69a;\r\n    border-radius: 4px;\r\n}\r\n\r\n.quick_answer__text.selected:hover {\r\n    background-color: #26a69a;\r\n    border-radius: 4px;\r\n}\r\n\r\n.quick_answer__text:hover {\r\n    background-color: #26a69a;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n}\r\n\r\n.quick_answer__close {\r\n    opacity: 0;\r\n    width: 2rem;\r\n    text-align: center;\r\n    font-size: initial;\r\n    position: absolute;\r\n    right: 0.5rem;\r\n    top: 50%;\r\n    transform: translateY(-50%)\r\n}\r\n\r\n.quick_answer__close:hover {\r\n    background-color: #26a69a;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n}\r\n\r\n.quick-answer:hover .quick_answer__text {\r\n    background-color: #26a69a;\r\n    color: #fff;\r\n    border-radius: 4px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
